import React from "react";
import { useLocation } from "react-router-dom";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_M4_PushRelabel = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <DAAModuleSubtopic
      title="Push-Relabel Algorithm - Maximum Flow using Preflow"
      videos={["https://www.youtube.com/embed/xcqZyG9CEAw", "https://www.youtube.com/embed/G_P_vQpPyt0", "https://www.youtube.com/embed/LjNzXyjMu5w"]}
      takeaways={[
        { text: "Instead of finding augmenting paths, it pushes flow locally using a preflow concept." },
        { text: "Nodes maintain an excess flow, and flow is pushed to neighboring nodes." },
        { text: "Uses relabeling to update height and prioritize where flow should go." },
        { text: "Fast on dense graphs (often outperforms Edmonds-Karp)." },
        { text: "Can be implemented using FIFO or highest-label selection for better performance." },
        { text: "Time Complexity: O(V²E) (or O(V³) in worst case)." },
        { text: "Example Use Case: Large-scale network flow problems, such as traffic optimization, image segmentation, or airline scheduling.", image: "/DAA_M4_summary.png" },
      ]}
      questions={["In water distribution systems, we need to find the maximum amount of water that can be supplied from source S to destination T through a network of pipes with capacity limitations. Given a directed graph G=(V,E) representing a water distribution system, where V is a set of vertices and E is the set of edges, each edge (u,v) has a capacity c(u,v) representing the maximum water flow that can be supplied through the network pipe. Use the Push Relabel algorithm to find the maximum water flow that can be supplied from node S to node T using the given graph."]}
      exampleVideos={[]}
      subtopics={subtopics}
      subjectPath={subjectPath}
    />
  );
};

export default DAA_M4_PushRelabel;